import { state } from "./state.js";
import { setStatus, setLogo, switchThemeMode } from "./dom/layout.js";
import { connectToWs } from "./ws.js";

const fetchInit = {
  method: "GET",
  headers: new Headers({ pragma: "no-cache", "cache-control": "no-cache" }),
};

function onloaded() {
  const urlParams = new URLSearchParams(window.location.search);
  state.debug = urlParams.get("debug") !== null;

  if (urlParams.get("dark") !== null) {
    document.getElementById("darkmode").checked = true;
    switchThemeMode(false);
  }

  state.pendingUrlTab = urlParams.get("class");
  state.scrollRequested = urlParams.get("scroll") !== null;
  state.gridRequested = urlParams.get("grid") !== null;

  setStatus("DISCONNECTED");

  fetch("config.json", fetchInit)
    .then((response) => response.text())
    .then((data) => {
      state.configJSON = JSON.parse(data);

      if (state.configJSON.hasOwnProperty("Logo")) {
        setLogo(state.configJSON.Logo);
      }

      connectToWs();
    });
}

// index.html still wires these up via inline attributes (onload/onclick).
window.onloaded = onloaded;
window.switchThemeMode = switchThemeMode;
